import PresupuestoService from "@/services/presupuesto.service";
import ObraService from "@/services/obra.service";

export const transaccion = [
  {
    label: "Id",
    name: "idtransaccion",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Fecha",
    name: "fecha",
    type: "DATE",
    allowNull: false,
    showOnList: true,
  },
  {
    label: "Tipo",
    name: "tipo",
    type: "STRINGINLIST",
    allowNull: false,
    options: ["Pago", "Cobro"],
    showOnList: true,
    onChange: (record) => {
      if (record.tipo !== "Pago") {
        record.pago_categoria_id = null;
        record.pago_subcategoria_id = null;
      }
    },
  },

  {
    label: "Presupuesto",
    name: "idpresupuesto",
    type: "presupuesto",
    showOnList: true,
    allowNull: (record) => {
      return record.pago_categoria_id ? true : false;
    },
    onChange: async (record) => {
      if (record.tipo === "Cobro" && record.idpresupuesto) {
        try {
          const presData = await PresupuestoService.get(record.idpresupuesto);
          const idobra = presData?.record?.idobra;
          if (idobra) {
            const obraData = await ObraService.get(idobra);
            const idempresa = obraData?.record?.idempresa;
            if (idempresa) {
              record.idempresa = idempresa;
            }
          }
        } catch (e) {
          console.error("Error al obtener empresa del presupuesto", e);
        }
      }
    },
  },
  {
    label: "Categoría",
    name: "pago_categoria_id",
    type: "pago_categoria",
    showOnList: true,
    conditionalDisplay: (record) => {
      return record.tipo === "Pago";
    },
    allowNull: (record) => {
      return record.idpresupuesto ? true : false;
    },
    onChange: (record) => {
      record.pago_subcategoria_id = null;
    },
  },
  {
    label: "Subcategoría",
    name: "pago_subcategoria_id",
    type: "pago_subcategoria",
    conditionalDisplay: (record) => {
      return record.tipo === "Pago";
    },
    allowNull: true,
    filterBy: {
      field: "idpago_categoria",
      value: (record) => record.pago_categoria_id,
    },
  },
  {
    label: (record) => {
      if (!record.tipo) return "Empresa";
      return record.tipo === "Pago" ? "Empresa proveedora" : "Empresa cliente";
    },
    name: "idempresa",
    type: "empresa",
    showOnList: true,
    allowNull: true,
    filterBy: {
      field: (record) => (record.tipo === "Pago" ? "proveedor" : "cliente"),
      value: (record) => (record.tipo ? true : null),
    },
  },
  {
    label: "Moneda",
    name: "idmoneda",
    type: "moneda",
  },
  {
    label: "Cuenta",
    name: "idcuenta",
    type: "cuenta",
    showOnList: true,
  },
  {
    label: "Monto",
    name: "monto",
    type: "DECIMAL",
    allowNull: false,
    step: 0.01,
    currency: true,
    showOnList: true,
    onChange: (record) => {
      // Recalcular porcentaje IVA cuando cambia el monto
      record.porcentaje_iva =
        record.monto > 0
          ? +(((record.monto_iva || 0) / record.monto) * 100).toFixed(2)
          : 0;

      // Recalcular monto comparativo si hay cotización
      record.monto_comparativo =
        record.cotizacion > 0
          ? +((record.monto || 0) / record.cotizacion).toFixed(2)
          : 0;
    },
  },
  {
    label: "Monto IVA",
    name: "monto_iva",
    type: "DECIMAL",
    allowNull: true,
    step: 0.01,
    currency: true,
    onChange: (record) => {
      // Recalcular porcentaje IVA cuando cambia el monto IVA
      record.porcentaje_iva =
        record.monto > 0
          ? +(((record.monto_iva || 0) / record.monto) * 100).toFixed(2)
          : 0;

      // Recalcular monto iva comparativo si hay cotización
      record.monto_comparativo_iva =
        record.cotizacion > 0
          ? +((record.monto_iva || 0) / record.cotizacion).toFixed(2)
          : 0;
    },
  },
  {
    label: "Porcentaje IVA",
    name: "porcentaje_iva",
    type: "DECIMAL",
    allowNull: true,
    step: 0.01,
    readonly: true,
    onChange: (record) => {
      // Recalcular monto IVA cuando cambia el porcentaje
      record.monto_iva = +(
        ((record.monto || 0) * (record.porcentaje_iva || 0)) /
        100
      ).toFixed(2);

      // También actualizar monto comparativo IVA si hay cotización
      record.monto_comparativo_iva =
        record.cotizacion > 0
          ? +((record.monto_iva || 0) / record.cotizacion).toFixed(2)
          : 0;
    },
  },
  {
    label: "Cotización",
    name: "cotizacion",
    type: "DECIMAL",
    step: 0.01,
    onChange: (record) => {
      // Recalcular montos comparativos cuando cambia la cotización
      record.monto_comparativo =
        record.cotizacion > 0
          ? +((record.monto || 0) / record.cotizacion).toFixed(2)
          : 0;
      record.monto_comparativo_iva =
        record.cotizacion > 0
          ? +((record.monto_iva || 0) / record.cotizacion).toFixed(2)
          : 0;
    },
  },
  {
    label: "Monto comparativo (USD)",
    name: "monto_comparativo",
    type: "DECIMAL",
    allowNull: false,
    step: 0.01,
    currency: true,
    showOnList: true,
    onChange: (record) => {
      // Recalcular cotización cuando cambia el monto comparativo
      record.cotizacion =
        record.monto_comparativo > 0
          ? +((record.monto || 0) / record.monto_comparativo).toFixed(2)
          : 0;

      // Recalcular monto comparativo IVA si hay cotización
      record.monto_comparativo_iva =
        record.cotizacion > 0
          ? +((record.monto_iva || 0) / record.cotizacion).toFixed(2)
          : 0;
    },
  },
  {
    label: "Monto comparativo IVA (USD)",
    name: "monto_comparativo_iva",
    type: "DECIMAL",
    allowNull: true,
    step: 0.01,
    currency: true,
    onChange: (record) => {
      // Recalcular cotización cuando cambia el monto comparativo IVA
      record.cotizacion =
        record.monto_comparativo_iva > 0
          ? +((record.monto_iva || 0) / record.monto_comparativo_iva).toFixed(2)
          : 0;

      // Recalcular monto comparativo si hay cotización
      record.monto_comparativo =
        record.cotizacion > 0
          ? +((record.monto || 0) / record.cotizacion).toFixed(2)
          : 0;
    },
  },
  {
    label: "Descripción",
    name: "descripcion",
    type: "STRING",
    showAsLabel: true,
    showOnList: true,
  },
  {
    label: "Realizada",
    name: "realizada",
    type: "BOOLEAN",
    showOnList: true,
    allowNull: true,
  },
];
